import * as React from 'react'
function SvgLocation(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M20.176 4C12.836 4 7 9.835 7 17.176c0 3.577 1.318 6.965 3.953 9.412.188.188 7.718 6.965 7.906 7.153.753.565 1.882.565 2.447 0 .188-.188 7.906-6.965 7.906-7.153 2.635-2.447 3.953-5.835 3.953-9.412C33.353 9.836 27.518 4 20.176 4zm0 16.941a3.776 3.776 0 01-3.764-3.765 3.776 3.776 0 013.764-3.764 3.776 3.776 0 013.765 3.764 3.776 3.776 0 01-3.765 3.765z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgLocation
